import { useRef } from "react";
const getMenuItems = (combobox, menuItemsSelector) => {
  if (combobox.current) {
    return Array.from(combobox.current.querySelectorAll(menuItemsSelector));
  }
  return [];
};
function useCombobox() {
  const combobox = useRef(null);
  const trigger = useRef(null);
  return [combobox, trigger];
}
const clearActiveItems = (combobox, prefix, trigger) => {
  const menuItems = getMenuItems(
    combobox,
    `.${prefix}menu-item:not(.${prefix}menu-item--disabled)`
  );
  if (menuItems && menuItems?.length > 0) {
    menuItems.forEach((item) => {
      item.classList.remove(`${prefix}menu-item--active`);
    });
    if (trigger.current) {
      trigger.current.setAttribute("active-descendant", "");
    }
  }
};
var KeyboardActions = /* @__PURE__ */ ((KeyboardActions2) => {
  KeyboardActions2[KeyboardActions2["open"] = 0] = "open";
  KeyboardActions2[KeyboardActions2["close"] = 1] = "close";
  KeyboardActions2[KeyboardActions2["select"] = 2] = "select";
  KeyboardActions2[KeyboardActions2["prevent"] = 3] = "prevent";
  KeyboardActions2[KeyboardActions2["navigation"] = 4] = "navigation";
  KeyboardActions2[KeyboardActions2["search"] = 5] = "search";
  return KeyboardActions2;
})(KeyboardActions || {});
const getActions = (keyboardEvent, isOpen, multiple) => {
  const { altKey, key, metaKey, ctrlKey } = keyboardEvent;
  const preventableKeys = [
    " ",
    "Enter",
    "ArrowDown",
    "ArrowUp",
    "PageUp",
    "PageDown",
    "Home",
    "End"
  ];
  const actions = [];
  if (preventableKeys.includes(key)) {
    if (key === "PageUp" || key === "PageDown") {
      if (isOpen) {
        actions.push(3 /* prevent */);
      }
    } else {
      actions.push(3 /* prevent */);
    }
  }
  if (key === "ArrowUp") {
    if (altKey && isOpen) {
      actions.push(2 /* select */);
      actions.push(1 /* close */);
      return actions;
    }
  }
  switch (key) {
    case " ":
    case "Enter":
      if (isOpen) {
        actions.push(2 /* select */);
        if (!multiple) {
          actions.push(1 /* close */);
        }
      } else {
        actions.push(0 /* open */);
      }
      break;
    case "ArrowUp":
    case "ArrowDown":
    case "Home":
    case "End":
      if (!isOpen) {
        actions.push(0 /* open */);
      } else {
        actions.push(4 /* navigation */);
      }
      break;
    case "PageUp":
    case "PageDown":
      if (isOpen) {
        actions.push(4 /* navigation */);
      }
      break;
    case "Tab":
      actions.push(1 /* close */);
      break;
    case "Escape":
      actions.push(1 /* close */);
      break;
    default:
      if (!altKey && !metaKey && !ctrlKey && key.length === 1) {
        actions.push(3 /* prevent */);
        actions.push(5 /* search */);
        if (!isOpen) {
          actions.push(0 /* open */);
        }
      }
      break;
  }
  return actions;
};
export {
  KeyboardActions,
  clearActiveItems,
  getActions,
  getMenuItems,
  useCombobox
};
